<template>
  <div class="share" onselectstart="return false;" @click="img_load()">
    <!-- 轮播图 -->
    <div class="block">
      <el-carousel :height="img_height + 'px'">
        <el-carousel-item>
          <img
            style="width: 100%"
            @load="img_load"
            ref="img"
            src="../assets/home/banner.jpg"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 热点产品与解决方案 -->
    <div class="title">热点产品与解决方案</div>
    <div class="line"></div>
    <!-- 方案整体模块 -->
    <div class="scheme-section">
      <div class="box"   @click="routerUrl('/BI')">
        <img
        
          src="../assets/home/bigdata-1.png"
          alt=""
        />
        <div class="EnglishFont">
          BI Big Data Business Intelligence solutions
        </div>
        <div class="font">BI大数据商业智能解决方案</div>
      </div>
      <div class="box"  @click="routerUrl('/RPA')" >
        <img src="../assets/home/RPA-1.png" alt="" />
        <div class="EnglishFont">
        RPA solutions
        </div>
        <div class="font">RPA解决方案</div>
      </div>
      <div class="box"  @click="routerUrl('/bank')">
        <img
         
          src="../assets/home/bank-2.png"
          alt=""
        />
        <div class="EnglishFont">
          Smart banking solutions
        </div>
        <div class="font">智能银行解决方案</div>
      </div>
    </div>
    <!-- 更多产品 -->
    <div class="moreproduct">
      <div @click="moreClick()">
        <span>更多产品</span>
        <img src="../assets/home/rightarrow.png" alt="" />
      </div>
    </div>
    <!-- 视频整体 -->
    <div class="video-main">
      <!-- 标题 -->
      <div class="title" style="color: #ffffff">雅格官方视频</div>
      <!-- 播放视频的地方 -->
      <div class="video-section">
        <div class="video">
          <video
            muted
            width="800"
            height="320"
            style="margin-top: 10px"
            controls
            autoplay
          >
            <source src="../assets/video/yage.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partner">
      <img
        style="width: 100%; height: auto"
        src="../assets/home/partner.jpg"
        alt=""
      />
      <div class="section">
        <div class="title">合作伙伴</div>
        <div class="line">
          <!-- <img src="../assets/home/line.png" alt="" /> -->
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      // 轮播图图片高度
      img_height: "",
    };
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      _this.img_load();
    };
  },
  computed: {},
  methods: {
    // 重新加载轮播图高度的控制
    img_load() {
      this.img_height = this.$refs.img.height;
    },
    // 跳转到具体方案页面
    routerUrl(url) {
      this.$router.push(url);
    },
    // 点击更多产品
    moreClick() {
      this.$message({
        message: "暂无更多产品！",
        type: "warning",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.share {
  width: 100%;
  font-family: Source Han Sans CN;
  margin: 0;
  padding: 0;
  position: relative;
  // 轮播图
  .block {
    width: 100%;
  }
  // 模块标题
  .title {
    text-align: center;
    width: 100%;
    margin: 20px auto;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
  }
  // 标题下划线
  .line {
    margin: 20px auto 60px;
    text-align: center;
    width: 100%;
    position: relative;
    div {
      width: 78px;
      height: 3px;
      background: linear-gradient(
        -90deg,
        rgba(0, 204, 255, 0.95),
        rgba(0, 61, 230, 0.95)
      );
      border-radius: 3px;
      position: absolute;
      top: 10px;
      left: calc(50% - 39px);
    }
  }
  // 整体方案模块
  .scheme-section {
    margin: 20px 15%;
    display: flex;
    justify-content: space-around;
    width: 80%;
    .box {
      width: 30%;
      height: auto;
      background: rgb(255, 255, 255);
      box-shadow: 0px 0px 21px 0px rgba(130, 169, 228, 0.3);
      opacity: 0.74;
      padding: 10px 0;
      border-radius: 16px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 220px;
      }
      .EnglishFont {
        width: 100%;
        font-size: 11px;
        text-align: center;
        color: #c2c2c2;
        margin: 10px auto;
      }
      .font {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        color: #405080;
        margin: 10px auto;
      }
    }
  }
  // 更多产品
  .moreproduct {
    display: flex;
    justify-content: space-around;
    margin: 40px auto;
    cursor: pointer;
    div {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #377eff;
      span {
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
      }
      img {
        vertical-align: middle;
        margin: 0 10px;
        width: 18px;
        height: 18px;
      }
    }
  }
  // 播放视频的地方
  .video-main {
    background-image: url("../assets/home/videobg.jpg");
    background-size: (100%, 100%);
    height: 560px;
    background-repeat: no-repeat;
    padding-top: 10px;
    box-sizing: border-box;
    .video-section {
      width: 800px;
      margin: 20px auto;
      height: 380px;
      background-color: #333333;
      .video {
        width: 800px;
        height: 320px;
        background: #000000;
      }
    }
  }
  // 合作伙伴
  .partner {
    position: relative;
    .section {
      position: absolute;
      top: 20px;
      width: 200px;
      text-align: center;
      left: calc(50% - 100px);
    }
  }

  // 悬浮图标
  .imgs {
    width: 101px;
    height: 202px;
    background: #ffffff;
    box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    position: sticky;
    right: 60px;
    top: 200px;
    z-index: 99999;
  }
}
</style>